/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiNftMedia {
    /**
    * The unique identifier for the NFT media
    */
    'id': string;
    /**
    * The URL of the NFT image
    */
    'image': string;
    /**
    * The URL of the NFT animation, if available
    */
    'animation': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "string",
            "format": ""
        },
        {
            "name": "animation",
            "baseName": "animation",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiNftMedia.attributeTypeMap;
    }

    public constructor() {
    }
}
